import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToTop } from '../../../utils'

const ScrollToTop = ({ offset = 0, behavior = 'smooth' }) => {
	const location = useLocation()

	useEffect(() => {
		scrollToTop(offset, behavior)
	}, [location.pathname, offset, behavior])

	return null
}

export default ScrollToTop
